import { createContext, useContext } from "react";

export interface SideSheetSlotContextValue {
  slot: HTMLElement | null;
  setStandardOpen: (open: boolean) => void;
  fullscreen: boolean;
  setFullscreen: (fullscreen: boolean) => void;
}

export const SideSheetSlotContext = createContext<SideSheetSlotContextValue | null>(null);

export function useSideSheetSlot(): SideSheetSlotContextValue | null {
  return useContext(SideSheetSlotContext);
}
